import "primeflex/primeflex.css";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import "primereact/resources/primereact.min.css";
import "./theme.css";
import "primeicons/primeicons.css";
import Layout from "./components/layout/Layout";
import { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/messaging";
import { Analytics } from "firebase/analytics";
import React from "react";
import Account from "./components/Account/Account";
import Login from "./components/auth/Login";
import Registrieren from "./components/auth/Registrieren";
/* import Pricing from "./components/Pricing/Pricing"; */
import SignInContainer from "./components/auth/SignInContainer";
import { getSubscription } from "./logik/apiCalls";
import CookieConsent from "./components/rechtsTexte/CookieConsent";
import StimmGeraet from "./components/tuning/StimmGeraet";
import Pricing from "./components/Pricing/Pricing";

export interface ContextIF {
    authenticated: boolean;
    hasPremium: boolean;
    user: firebase.User | null;
    installPrompt: any;
}

export const MyContext = React.createContext<ContextIF>({
    authenticated: false,
    hasPremium: false,
    user: null,
    installPrompt: null,
});
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDQSHQ9CKZZdBp_l8Yei_F2KoJY0M5AeqA",
    authDomain: "tischharfenstimmgeraet.firebaseapp.com",
    projectId: "tischharfenstimmgeraet",
    storageBucket: "tischharfenstimmgeraet.appspot.com",
    messagingSenderId: "344216739545",
    appId: "1:344216739545:web:7445b383b49f24e67da8c8",
    measurementId: "G-DW48YKXWX3",
};

export let fb: firebase.app.App | null = null;
export let db: firebase.firestore.Firestore | null = null;
export let analytics: Analytics | null = null;
export let auth: firebase.auth.Auth | null = null;

function App() {
    const [isSignedIn, setIsSignedIn] = useState(false); // Local signed-in state.
    const [hasPremium, setHasPremium] = useState(false); // Local signed-in state.
    const [currentUser, setCurrentUser] = useState<firebase.User | null>(null); // Local signed-in state.
    const [installPrompt, setInstallPrompt] = useState<any>(null); // Local signed-in state.
    const [authobserverUnregister, setAuthobserverUnregister] =
        useState<any>(null);
    const [messaging, setMessaging] = useState<any>(null);
    const [dbState, setDbState] = useState<any>(null);
    const [cookies, setCookies] = useState(false);

    // Listen to the Firebase Auth state and set the local state.
    useEffect(() => {
        //Notification.requestPermission()
        window.addEventListener("beforeinstallprompt", (e: any) => {
            // Don't show mini-infobar
            e.preventDefault();

            // Stash the event so it can be triggered later.
            setInstallPrompt(e);
            console.log(e);
            // Update UI to promote PWA installation
        });
        // Add the public key generated from the console here.

        return () => authobserverUnregister(); // Make sure we un-register Firebase observers when the component unmounts.
    }, []);

    const onCookieAccept = () => {
        window.localStorage.setItem("cookieconsent", "true");
        setCookies(true);
        // Initialize Firebase
        fb = firebase.initializeApp(firebaseConfig);
        db = firebase.firestore();
        setDbState(db);
        auth = firebase.auth();
        fb.auth().useDeviceLanguage();
        console.log(db);
        let m = firebase.messaging();
        m.onMessage(function (payload) {
            console.log("Message received. ", payload);
        });
        analytics = fb.analytics();
        setMessaging(m);
        db.enablePersistence();
        const unregisterAuthObserver = firebase
            .auth()
            .onAuthStateChanged(async (user) => {
                setIsSignedIn(!!user);
                if (!!user) {
                    setCurrentUser(user);
                    var subs = await getSubscription();
                    subs.forEach((sub) => {
                        if (sub.data().status === "active") {
                            if (
                                sub.data().product.id === "prod_M1dv4OWMXwwyDA"
                            ) {
                                setHasPremium(true);
                            }
                        }
                    });
                } else {
                    setHasPremium(false);
                    setCurrentUser(null);
                }
            });
        setAuthobserverUnregister(unregisterAuthObserver);
    };

    return (
        <MyContext.Provider
            value={{
                authenticated: isSignedIn,
                hasPremium: hasPremium,
                user: currentUser,
                installPrompt: installPrompt,
            }}
        >
            <Layout>
                <Switch>
                    <Route exact path="/">
                        <StimmGeraet
                            messaging={messaging}
                            setMassaging={setMessaging}
                            cookies={cookies}
                            db={dbState}
                        />
                    </Route>
                    <Route exact path="/login">
                        {isSignedIn ? (
                            <Redirect to="/" />
                        ) : (
                            <SignInContainer cookies={cookies} />
                        )}
                    </Route>
                    <Route path="/login/email">
                        {isSignedIn ? <Redirect to="/" /> : <Login />}
                    </Route>
                    <Route path="/registrieren">
                        {isSignedIn ? <Redirect to="/" /> : <Registrieren />}
                    </Route>
                    <Route path="/premium">
                        <Pricing />
                    </Route>
                    <Route path="/account">
                        <Account />
                    </Route>
                </Switch>
                <CookieConsent onAccept={onCookieAccept} />
            </Layout>
        </MyContext.Provider>
    );
}

export default withRouter(App);
